/* global __ENV_IS_BBC__:false, __DEBUG__:false, __WATCH__:false */
import Phaser from 'phaser';
import WebFont from 'utils/webfontloader';
import CopyController from '../controller/CopyController';
import {
  GAME_BACKGROUND_COLOR,
  STATE_LOAD,
  FONT_TITLE,
  FONT_COPY,
  FONT_TITLE_OVERRIDE,
} from '../constants/AppConstants';

export default class Boot extends Phaser.State {
  init(options) {
    // TODO : parse urls through global parser
  }

  preload() {
    // set flags for load checking
    this.fontsReady = false;
    this.loadComplete = false;

    //game assets
    this.game.load.baseURL = './assets/';
    this.game.load.crossOrigin = 'anonymous';
    this.game.load.pack('boot', 'assetpack.json', null, this);

    // Set BG colour
    this.game.backgroundColor = '#00a2cc';

    WebFont.load({
      custom: {
        families: [FONT_TITLE, FONT_COPY, FONT_TITLE_OVERRIDE],
        urls: ['assets/fonts/fonts.css'],
      },
      active: this.fontsLoaded.bind(this),
      inactive: this.fontsLoaded.bind(this),
    });
  }

  fontsLoaded() {
    this.fontsReady = true;
  }

  create() {
    this.stage.backgroundColor = GAME_BACKGROUND_COLOR;
    this.game.scale.scaleMode = Phaser.ScaleManager.USER_SCALE;
    this.game.scale.fullScreenScaleMode = Phaser.ScaleManager.USER_SCALE;
    this.game.scale.pageAlignHorizontally = false;
    this.game.scale.pageAlignVertically = false;
    this.game.stage.disableVisibilityChange = false;

    // load in copy xml ( we have the country now :) )
    const config = this.game.cache.getJSON('app_config');

    // query browser url
    const urlQuery = this.game.net.getQueryString();

    this.game.titleFontStyle;

    // check for local override
    if (urlQuery.locale) {
      this.game.language = urlQuery.locale;
    } else {
      // if no override pull from config
      this.game.language = config.default_language;
    }

    // Setup which font to use
    this.game.titleFontStyle = config.font_language.fredburger.includes(this.game.language)
      ? FONT_TITLE_OVERRIDE
      : FONT_TITLE;

    // Setup font direction if it needs to be right aligned
    this.game.fontAlign = this.game.language == 'ar' ? 'right' : 'left';

    // set available languages
    this.game.languagesAvailable = config.available_languages;

    // generate local assetpack
    const localAsssets = {
      assets: [
        {
          type: 'image',
          key: 'logo_welcome',
          url: 'locale/' + this.game.language + '/scooby_doo_logo.png',
          overwrite: true,
        },
        {
          type: 'xml',
          key: 'copy_xml',
          url: 'locale/' + this.game.language + '/copy.xml',
          overwrite: true,
        },
        {
          type: 'image',
          key: 'boomerang_logo',
          url: 'locale/' + this.game.language + '/boomerang_logo.png',
          overwrite: true,
        },

        {
          type: 'image',
          key: 'certificate_thumbnail',
          url: 'locale/' + this.game.language + '/certificate_thumbnail.png',
          overwrite: true,
        },
        {
          type: 'audiosprite',
          key: 'general_vo',
          urls: [
            'locale/' + this.game.language + '/audio/general_vo.m4a',
            'locale/' + this.game.language + '/audio/general_vo.ogg',
            'locale/' + this.game.language + '/audio/general_vo.mp3',
          ],
          jsonURL: 'locale/' + this.game.language + '/audio/general_vo.json',
          jsonData: null,
          autoDecode: true,
        },
      ],
    };

    this.game.load.pack('assets', null, localAsssets);
    this.game.load.onLoadComplete.add(this.handleLocalContentLoaded, this);
    this.game.load.start();

    // todo : touch event flag for this?
    this.game.isTouch =
      'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

    //this.loadComplete = true;
    this.game.windowEventController.handleWindowResize();
  }

  handleLocalContentLoaded() {
    this.game.copy = new CopyController(this.game, this.game.cache.getXML('copy_xml'));

    // register general VO
    this.game.sounds.addAudioSprite({ id: 'general_vo' });

    //
    this.loadComplete = true;
  }

  update() {
    this.checkLoading();
  }

  checkLoading() {
    if (this.loadComplete && this.fontsReady) {
      this.game.state.start(STATE_LOAD, true, false);
    }
  }
}



// WEBPACK FOOTER //
// ./js/app/states/Boot.js